import React from 'react';
import { Box, Container, List, ListItem, ListItemText, Stack, Typography } from '@mui/material';
import Header from './header';
import MainBanner from './mainBanner';
import Footer from './footer';
import ContactUs from './contactUs';

const AboutBrand = () => {
    // const theme = useTheme();

    const keyHighlights = [
        { value: 'Complete video production from A-Z.' },
        { value: 'Fast, high-quality content with in-house teams.' },
        { value: 'Experts in social media, events, and promotional videos.' },
    ];

    const processSteps = [
        { title: 'Understanding Your Vision', description: 'We get to know your brand, goals, and audience to shape video content that resonates.' },
        { title: 'Creative Concept & Strategy', description: 'We work with you to create a unique video concept aligned with your objectives and brand message.' },
        { title: 'Production Excellence', description: 'Our skilled in-house team uses top equipment and techniques to produce high-quality footage.' },
        { title: 'Post-Production & Optimization', description: 'We edit and optimize the video to ensure it’s polished and perfect for each platform.' },
        { title: 'Delivery & Impact', description: 'We distribute and promote your video to maximize reach and track its performance for real results.' },
    ];

    const coreValues = [
        { title: 'Quality', description: 'We believe in delivering only the best, every time.' },
        { title: 'Creativity', description: 'We approach every project with fresh, innovative ideas.' },
        { title: 'Collaboration', description: 'We work closely with our clients to bring their vision to life.' },
        { title: 'Integrity', description: 'We maintain transparency and honesty in all our dealings.' },
        { title: 'Impact', description: 'We create content that not only looks good but also delivers measurable results.' },
    ];

    const commitmentText = `At GrooveNexus, we create more than just videos—we craft experiences that engage and inspire. Our mission is to help your brand connect with its audience, build lasting relationships, and drive action. Whether you're boosting your social media, launching a product, or covering an event, we’re here to bring your vision to life. Let’s create something extraordinary together.`;

    return (
        <Box className="landing-container">
            <Container className="p-0 mobilepadding">
                <Header />
                <MainBanner />
            </Container>

            <Box
                sx={{
                    mt: 5,
                    px: { xs: 2, sm: 4, md: 6 },
                    py: { xs: 3, sm: 4 },
                    backgroundColor: '#f9f9f9',
                    borderRadius: 2,
                    boxShadow: 1,
                }}
            >
                <Stack spacing={2}>
                    <Typography variant="h6" fontWeight={600}>
                        About
                    </Typography>
                    <Typography variant="body1">
                        At GrooveNexus, we bring your brand’s vision to life through powerful video content. We create engaging videos tailored to your needs—for social media, events, promotions and the list is endless.
                    </Typography>
                    <Typography variant="body1">
                        Our team handles every step of the process, from concept to final edit. With a focus on storytelling, we craft videos that connect emotionally with your audience, build trust, and drive action.
                    </Typography>
                    <Typography variant="body1">
                        Our mission is to make high-quality video production easy and accessible for businesses of all sizes. With a blend of creativity, cutting-edge technology, and great storytelling, we craft videos that not only look amazing but also deliver real impact.
                    </Typography>
                    <Typography variant="body1">
                        Let us help your brand shine with engaging, action-driven videos.
                    </Typography>

                    <Typography variant="h6" fontWeight={600} sx={{ mt: 3 }}>
                        Key Highlights
                    </Typography>
                    <List dense>
                        {keyHighlights.map((item, i) => (
                            <ListItem key={i} disablePadding>
                                <ListItemText primary={`• ${item.value}`} />
                            </ListItem>
                        ))}
                    </List>

                    <Typography variant="h6" fontWeight={600} sx={{ mt: 3 }}>
                        Our Process
                    </Typography>
                    <List dense>
                        {processSteps.map((step, index) => (
                            <ListItem key={index} disablePadding sx={{ mb: 1 }}>
                                <ListItemText
                                    primary={
                                        <Typography variant="subtitle1" fontWeight={600}>
                                            {step.title}
                                        </Typography>
                                    }
                                    secondary={step.description}
                                />
                            </ListItem>
                        ))}
                    </List>

                    <Typography variant="h6" fontWeight={600} sx={{ mt: 3 }}>
                        Our Core Values
                    </Typography>
                    <List dense>
                        {coreValues.map((value, index) => (
                            <ListItem key={index} disablePadding sx={{ mb: 1 }}>
                                <ListItemText
                                    primary={
                                        <Typography variant="subtitle1" fontWeight={600}>
                                            {value.title}
                                        </Typography>
                                    }
                                    secondary={value.description}
                                />
                            </ListItem>
                        ))}
                    </List>

                    <Typography variant="h6" fontWeight={600} sx={{ mt: 3 }}>
                        Our Commitment to You
                    </Typography>
                    <Typography variant="body1">{commitmentText}</Typography>
                </Stack>
            </Box>

            <ContactUs />
            <Footer />
        </Box>
    );
};

export default AboutBrand;
